<template>

  <b-row style="width: 100%;">

    <b-col sm="6" lg="6" xl="3" v-for="(card, index) in cards" :key="`dashboard-card-${index}`">

      <b-card no-body :class="card.classes">

        <b-card-body class="pb-0">
          <h4 class="mb-0">{{card.total}}</h4>
          <p>{{card.title}}</p>
        </b-card-body>

        <div v-if="card.type == 'Bar'">
          <chartBar class="chart-wrapper px-3" style="height:100px;" :labels="card.labels" :data="card.data" :title="card.title"/>
        </div>

        <div v-if="card.type == 'Line'">
          <chartLine class="chart-wrapper px-3" style="height:100px;" :labels="card.labels" :data="card.data" :title="card.title"/>
        </div>

      </b-card>

    </b-col>

  </b-row>

</template>

<script>
import chartLine from '@/components/ui/ChartLine'
import chartBar from '@/components/ui/ChartBar'
import { resolveHTTP } from '@/services/api'
import { get } from 'lodash'

export default {
  components: {
    chartLine,
    chartBar
  },
  data () {
    return {
      cards: {}
    }
  },
  methods: {
    get,
    refresh () {
      let self = this
      resolveHTTP('/dashboard/cards').index()
        .then(function (res) {
          self.cards = res.data
        })
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style scoped="" lang="scss">
  .card {
    border: 0px;
    -webkit-box-shadow: 1px 3px 15px -4px rgba(0,0,0,0.48);
    -moz-box-shadow: 1px 3px 15px -4px rgba(0,0,0,0.48);
    box-shadow: 1px 3px 15px -4px rgba(0,0,0,0.48);
    &.bg-primary {
      background: #01a1db; /* Old browsers */
      background: -moz-linear-gradient(45deg, #01a1db 0%, #1ed3f2 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(45deg, #01a1db 0%,#1ed3f2 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(45deg, #01a1db 0%,#1ed3f2 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#01a1db', endColorstr='#1ed3f2',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    }
    &.bg-info {
      background: #4462d4; /* Old browsers */
      background: -moz-linear-gradient(45deg, #4462d4 0%, #7956e8 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(45deg, #4462d4 0%,#7956e8 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(45deg, #4462d4 0%,#7956e8 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4462d4', endColorstr='#7956e8',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    }
    &.bg-warning {
      background: #275ad0; /* Old browsers */
      background: -moz-linear-gradient(45deg, #275ad0 0%, #0f96e7 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(45deg, #275ad0 0%,#0f96e7 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(45deg, #275ad0 0%,#0f96e7 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#275ad0', endColorstr='#0f96e7',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    }
    &.bg-danger {
      background: #e36940; /* Old browsers */
      background: -moz-linear-gradient(45deg, #e36940 0%, #fe4c88 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(45deg, #e36940 0%,#fe4c88 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(45deg, #e36940 0%,#fe4c88 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e36940', endColorstr='#fe4c88',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Chart/Cards.vue